class Progressbar
    constructor: (el) ->
        @.$el = el

        @.max = @.$el.max ? 100
        @.progress = @.$el.value ? 0

        @.$el.classList.add 'progressbar--bound'
        @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'progressbar-set-max', (e) ->
            max = e.detail?.max ? 0
            self.SetMax max
            return
        @.$el.addEventListener 'progressbar-set-value', (e) ->
            progress = e.detail?.progress ? 0
            self.SetProgress progress
            return
        return

    SetMax: (max) ->
        max = max ? 100
        max = if max < 0 then 0 else max
        @.$el.max = max
        @.max = max
        
    SetProgress: (progress) ->
        progress = progress ? 0
        progress = if progress < 0 then 0 else (if progress > @.max then @.max else (if progress < @.min then @.min else progress))
        @.$el.value = progress
        @.progress = progress
        return

BindProgressbars = ->
    document.querySelectorAll '.progressbar:not(.progressbar--bound)'
        .forEach (el) ->
            new Progressbar el
            return
    return

window.addEventListener 'bind-components', BindProgressbars

class ProgressbarCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.color = options?.color
        @.id = options?.id ? false
        @.max = options?.max ? 100
        @.progress = options?.progress ? 50
        @.tag = 'progress'

        @.CreateElement()
        if !@.bindLater
            new Progressbar @.$el
        return @.$el

    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'progressbar'
        @.$el.max = @.max
        @.$el.value = @.progress
        if @.id
            @.$el.id = @.id
        if @.color
            @.$el.classList.add "progressbar--#{ @.color }"
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        return

window.CreateProgressbar = (options) ->
    return new ProgressbarCreate options